import React from 'react'
import { Text } from 'grommet'
import { Refresh } from 'grommet-icons'
import { AbsoluteBox } from '../Common'
import { useSelector, useDispatch } from 'react-redux'
import IconButton from '../Button/IconButton'
import TipDrop from '../Button/TipDrop'
import { resetSpinQuantity } from '../../redux/turntable/actions'

const SpinQuantity = () => {
  const spinQuantity = useSelector(state => state.turntable.spinQuantity)
  const dispatch = useDispatch()
  return (
    <AbsoluteBox
      bottom="-2rem"
      left="50%"
      transform="translate(-50%, 0)"
      direction="row"
      align="center"
      gap=".8rem"
    >
      <Text size="1.6rem" weight={600} color="inactive">
        Total spin = {spinQuantity}
      </Text>

      <IconButton
        icon={
          <TipDrop content="Reset spin count" position="bottom">
            <Refresh size="16px" color="inactive" />
          </TipDrop>
        }
        onClick={() => {
          dispatch(resetSpinQuantity())
        }}
      />
    </AbsoluteBox>
  )
}

export default SpinQuantity
